import React, {FC, useState} from 'react';

import {PhoneCountryCodeInputBox} from '../../../../components/common/boxedInputs/phoneCountryCodeInputBox';
import {SettingsPreferenceItemInheritableProps} from '../../settingsPreferencesList';

/*
 * Props.
 */

interface DefaultPhoneNumberPrefixInputProps extends SettingsPreferenceItemInheritableProps<string> {
  value: string;
}

/*
 * Component.
 */

export const DefaultPhoneNumberPrefixInput: FC<DefaultPhoneNumberPrefixInputProps> = (props) => {
  const {updatePreference, value} = props;
  const [hasError, setHasError] = useState(false);
  return (
    <PhoneCountryCodeInputBox
      hasError={hasError}
      phoneCountryCode={value}
      onChange={(countryCode) => {
        updatePreference(countryCode);
        setHasError(!checkIsValidPhoneNumberPrefix(countryCode));
      }}
    />
  );
};

export function checkIsValidPhoneNumberPrefix(countryCode: string) {
  const validPhoneNumberPrefixRegexp = /^\+\d{1,3}$/;
  return validPhoneNumberPrefixRegexp.test(countryCode);
}
